import { render, staticRenderFns } from "./BoDNewsList.vue?vue&type=template&id=3e6bb17e&"
import script from "./BoDNewsList.vue?vue&type=script&lang=js&"
export * from "./BoDNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports